import React, { useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom';

import moment from 'moment';

import { SVGIcon } from '../../wrappers/SVGIcon';

import { EExpertChatSource, IExpertConversationWithChatsForUser } from '../../../interfaces/expert_chats';

import { Icons } from '../../../data/Assets';


interface InboxListItemProps {
  expertConversation: IExpertConversationWithChatsForUser;
  selected: boolean;
};

const InboxListItem = (props: InboxListItemProps) => {
  const { expertConversation, selected } = props;

  const { id, student_name, expert_chats } = expertConversation;

  const navigate = useNavigate();

  const [formattedTimestamp, setFormattedTimestamp] = useState('');

  const lastMessage = expert_chats?.[expert_chats.length - 1] ? expert_chats[expert_chats.length - 1] : {
    id: 0,
    expert_conversation_id: expertConversation.id,
    source: EExpertChatSource.EXPERT,
    created_at: new Date(),
    message: 'New conversation has been created.',
  };

  useEffect(() => {
    const customFormatTimestamp = (timestamp: Date) => {
      const now = moment();
      const time = moment(timestamp);

      const diffInSeconds = now.diff(time, 'seconds');

      if (diffInSeconds < 60) {
        return `Now`;
      } else if (diffInSeconds < 3600) {
        return `${now.diff(time, 'minutes')}M`;
      } else if (diffInSeconds < 86400) {
        return `${now.diff(time, 'hours')}H`;
      } else if (diffInSeconds < 604800) {
        return `${now.diff(time, 'days')}D`;
      } else {
        return `${now.diff(time, 'weeks')}W`;
      }
    };

    setFormattedTimestamp(customFormatTimestamp(lastMessage.created_at));
    const interval = setInterval(() => {
      setFormattedTimestamp(customFormatTimestamp(lastMessage.created_at));
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, [lastMessage.created_at]);

  const handleClick = () => {
    navigate(`/immigration-help/details/${id}`);
  };

  return (
    <div className={`immersion__immigration_help__inbox__list__item ${selected ? 'immersion__immigration_help__inbox__list__item__selected' : ''}`} onClick={handleClick}>
      <div className='immersion__immigration_help__inbox__list__item__avatar'>
        {/* <img src={avatar} alt='avatar' /> */}
        <SVGIcon src={Icons.UserCircleFill} />
      </div>
      <div className='immersion__immigration_help__inbox__list__item__content'>
        <h5 className='immersion__immigration_help__inbox__list__item__content__name'>
          {student_name}
        </h5>
        <p className='immersion__immigration_help__inbox__list__item__content__message mice'>
          {lastMessage.message}
        </p>
      </div>
      <p className='immersion__immigration_help__inbox__list__item__timestamp mice'>
        {formattedTimestamp}
      </p>
    </div>
  )
}

export default InboxListItem;